import { isProduction } from "@/helpers/global/env.func";

export const config = {
  company: 'cmbi',
  market: 'hk',
  locale: 'hk',
  version: 'itrade7.5-v7.0.1',
  company_title: 'company_title',
  language: ['zh_TW', 'zh_CN', 'en_US'],
  routerPrefix: isProduction() ? (window.config?.webPath && `/${window.config.webPath}` || '') : '',
  thirdPartyLink: '',
  checkTabs: false,
  apis: {
    winvestorApi: true,
    mdsApi: true,
  },
  layouts: {
    fullLayout: {
      logoImgName: 'logo_dark.png',
    },
    mainLayout: {
      logoImgName: 'logo_light.png',
    }
  },
  pages: {
    login: {
      ctrl: { securityTips: false }
    },
    trade:{
      ctrl:{ 
        searchDropdown: true,
      }
    },
    market:{
      init:{ isOpenPieChart : true },
      ctrl:{ placeOrder : true }
    },
    account:{
      ctrl:{ disablePlaceOrder : true }
    },
    ipo:{
      margin:{
        disableCancel:false
      },
      cancel:{
        useIpoAppliedDetailsEnquiryAPI:false
      }
    }
  },
  reducers: {
    app: {
      mode: 'embedded'
    }
  },
  helpers:{
    functions:{
      accountToOption: true
    }
  },
  actions: {},
  constants: {
    winVest: {
      winvestorDeviceID: 'itrade7.5-web-cmbi',
      winvestorConsumerId: 'winvestor_cmbi_broker',
      winvestorConsumerSecret: '',
    },
    apiEnv: {
      itradeAPI: '',
      itradePath: '',
    
      MDSStreamingAPI: '',
      MDSSnapshotAPI: '',
      MDSOthersAPI: '',
      MDSPath: '',

      MDSEntityKey: '',
      MDSSuperkey: '',
    
      winvestorAPI: '',
      winvestorPath: 'ttl/api'
    },
    exportExeclFile: 'true'
  }
}